import { AreaCodeDropdown } from "../actionTypes/master/AreaCodeDropdownActionType";
import { StateDropdown } from "../actionTypes/master/StateDropdownActionType";

export const getStateDropdownList = (payload: { stateName?: string }) => ({
  type: StateDropdown.GET_STATE_DROPDOWN_LIST,
  payload,
});

export const setStateDropdownList = (payload: any[]) => ({
  type: StateDropdown.SET_STATE_DROPDOWN_LIST,
  payload,
});

export const getAreaCodeDropdown = (payload: {
  page: number;
  pageLimit: number;
  search?: string;
}) => ({
  type: AreaCodeDropdown.GET_AREA_CODE_DROPDOWN_LIST,
  payload,
});

export const setAreaCodeDropdownList = (payload: any[]) => ({
  type: AreaCodeDropdown.SET_AREA_CODE_DROPDOWN_LIST,
  payload,
});